module.exports = "/fonts/Font-Awesome-5-Free-Solid-900.otf?b1bd11fb772a5416cb0e3b79171db0a7";